import PInput from 'react-phone-input-2';
import './phoneinput-styles.css';
import React from 'react';
import {connect} from 'react-redux';

function mapStateToProps(state, props) {
    return {
        country: (state.settings.country_code || 'us').toLowerCase()
    }
}

export default connect(mapStateToProps)(({country, onChange, value}) => {
    let v = value && value.substring(0, 1) === "+" ? value.replace("+", '') : value;
    return <PInput
        country={country || null}
        value={v}
        preferredCountries={['us', 'ca', 'fr', 'de', 'in', 'it', 'ru', 'sw', 'myr']}
        onChange={phone => onChange({target: {value: phone ? "+" + phone : ''}})}
    />
})
